export default __webpack_public_path__ + "static/media/product-02 (1).53a49479.jpg";